 
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('header .btn_menu').forEach(function (btn) {
    var header = btn.closest('header');
    var menuDrawer = document.querySelector('#Details-menu-drawer-container'); // target element
    var menuIcon = document.querySelector('.header__icon--menu');
    if (!header) return;
    btn.addEventListener('click', function () {
     const isActive = header.classList.toggle('active');
 if (menuDrawer) {
        menuDrawer.classList.toggle('menu-opening');
          menuDrawer.setAttribute('open','');
      }
      if (menuIcon) {
        menuIcon.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
 
    });
  });
});
 
document.addEventListener('DOMContentLoaded', function () {
  const CUISINE_PARAM = 'filter.p.m.custom.cuisine';
 
  const cityValueByHandle = {
    'calabasas': 'Calabasas',
    'agoura': 'Agoura',
    'oak-park': 'Oak Park',
    'westlake-village': 'Westlake Village',
    'thousand-oaks': 'Thousand Oaks',
    'newbury-park': 'Newbury Park'
  };
 
  function getSelectByLabel(root, label) {
    return Array.from(root.querySelectorAll('select')).find(function (select) {
      return (select.getAttribute('aria-label') || '').toLowerCase().includes(label);
    });
  }
 
  document.querySelectorAll('.btn_search').forEach(function (button) {
    button.addEventListener('click', function (event) {
      const searchBlock = button.closest('.hp_sec1, .mainbanner.collection');
      if (!searchBlock) return;
 
      const cuisineSelect = getSelectByLabel(searchBlock, 'cuisine');
      const locationSelect = getSelectByLabel(searchBlock, 'location');
      const cuisineValue = cuisineSelect ? cuisineSelect.value : '';
      const cityHandle = locationSelect ? locationSelect.value : '';
      const cityValue = cityValueByHandle[cityHandle] ?? '';
      const url = new URL('/collections/restaurants', window.location.origin);
 
      if (cuisineValue && cuisineValue !== 'any') {
        // Send every stored spelling (Mexican, mexican, maxican...) – Shopify ORs them.
        const opt = cuisineSelect.options[cuisineSelect.selectedIndex];
        const variants = ((opt && opt.getAttribute('data-variants')) || cuisineValue).split('|');
        variants.forEach(function (v) { url.searchParams.append(CUISINE_PARAM, v); });
      }
 
      if (cityValue) {
        url.searchParams.set('filter.p.m.custom.city', cityValue);
      }
 
      event.preventDefault();
      window.location.href = url.pathname + url.search;
    });
  });
});
 
 
 